export default __webpack_public_path__ + "static/media/sticker-2.853a0bbf.png";